<template>
  <v-form :submit="submitUpdate">
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field label="Nome"
                      v-model="value.name"
                      density="compact"
                      :rules="rules.required">
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
                  label="Tipo"
                  item-title="label"
                  item-value="value"
                  v-model="value.type"
                  :items="$PAYMENT_METHOD_TYPES"
                  clearable
                  density="compact"
                  :rules="rules.required"
                  hide-details></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-text-field label="Valor Mínimo"
                      type="number"
                      v-model="value.minimum_due_amount"
                      density="compact">
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field label="Taxa GGrupos"
                      type="number"
                      v-model="value.tax_1"
                      density="compact">
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field label="Taxa Operadora"
                      type="number"
                      v-model="value.tax_3"
                      density="compact">
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field label="Taxa Mínima"
                      type="number"
                      v-model="value.tax_4"
                      density="compact">
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field label="Prazo para Pagamento"
                      type="number"
                      v-model="value.payment_delay"
                      density="compact"
                      :rules="rules.requiredIfOnline">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-switch color="green" :label="value.enabled ? 'Ativo' : 'Inativo'" v-model="value.enabled"></v-switch>
      </v-col>
      <v-col cols="2">
        <v-switch color="blue" label="Pagamento Online?" v-model="value.allow_online_payment"></v-switch>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="success" type="submit"><v-icon class="mr-2">mdi-content-save</v-icon> Salvar</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ["update:modelValue", 'created', 'updated'],
  data() {
    return {
      requestingApi: null,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
        required0: [(v) => (v == null || v != 0 && !!v || v < 0) || "Campo obrigatório e deve ser maior que zero"],
        requiredIfOnline: [(v) => (!!v && this.value.allow_online_payment || !this.value.allow_online_payment) || "Campo obrigatório para pagamentos online"],
      },
    };
  },
  created() {
    var vm = this;

    if (!vm.modelValue?.id) {
      vm.value = vm.generateEmpty();
    }

  },
  mounted() { },
  methods: {
    submitUpdate() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.paymentMethod
          .updateOrCreate(vm.value)
          .then((result) => {
            if (vm.value.id) {
              vm.$emit("updated", result);
              vm.$notify({
                type: "success",
                text: "Froma de pagamento atualizada com sucesso",
              });
            } else {
              vm.$emit("created", result);
              vm.$notify({
                type: "success",
                text: "Froma de pagamento criada com sucesso",
              });
            }
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    generateEmpty() {
      return {
        name: null,
        description: null,
        enabled: true,
        minimum_due_amount: null,
        allow_online_payment: null,
        payment_delay: null,
        tax_1: null,
        tax_2: null,
        tax_3: null,
        tax_4: null,
        tax_5: null,
        tax_6: null,
        data: null,
      };
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {},
};
</script>